import { ApiUrl } from "../../ApiUrl";

export const fetchAllClasses = async () => {
  try {
    const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass/`);
    if(!response.ok) {
        throw new Error("Failed to fetch classes");
    }
    const result = await response.json();
    return Array.isArray(result?.data) ? result.data : [];
  } catch (error) {
    console.error("Error fetching all classes:", error);
    return [];
  }
};
